import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldArrayType } from '@ngx-formly/core';
import { ModalService } from '../../../../services';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-ff-repeat',
  styleUrls: ['repeat.component.scss'],
  templateUrl: 'repeat.component.html',
  imports: [...MSS_FORMLY_IMPORTS, ReactiveFormsModule, FormsModule, CommonModule],
})
export class FormlyRepeatComponent extends FieldArrayType {
  private readonly modalService = inject(ModalService);

  openTooltip(triggerButton: HTMLElement) {
    this.modalService
      .open({
        title: this.props.addText,
        message: this.props.helpText,
        hideClose: true,
        showButtons: true,
        hideSubmit: true,
        cancelLabel: 'Close',
        defaultFocus: 'content',
      })
      .then(
        () => triggerButton.focus(),
        () => triggerButton.focus(),
      );
  }

  close() {
    this.modalService.close();
  }
}
